import { Component } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { DialogWrapperComponent } from "@bitwarden/web-vault/app/components/wrappers/dialog-wrapper/dialog-wrapper.component";
import { RIGHT_PANEL_CONFIG } from "@bitwarden/web-vault/app/models/constants/global.constants";

/** Opens the "confirming your payment" panel shown while a Stripe return is being finalized. The
 *  caller closes it once finalizing resolves and opens the receipt (or the buy drawer) in its place,
 *  the same swap-by-reopen as the receipt itself (see CreditsAddedComponent). */
export function openPurchaseProcessingDialog(dialog: MatDialog): MatDialogRef<unknown> {
  return dialog.open(DialogWrapperComponent, {
    ...RIGHT_PANEL_CONFIG,
    data: {
      title: "getMoreGoldCredits",
      showBackButton: false,
      component: PurchaseProcessingComponent,
    },
  });
}

/**
 * Pending state for a Stripe return. finalizePurchase can take up to ~105s with a slow webhook
 * (90s status poll + 15s detail poll), and showing nothing for that long reads as a failed
 * payment, which invites paying a second time. Hence the explicit "don't pay again" line.
 */
@Component({
  selector: "app-purchase-processing",
  templateUrl: "./purchase-processing.component.html",
})
export class PurchaseProcessingComponent {}
